import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const USTrademarkImageDownload = () => {
  const faqs = [
    {
      question: "Q: What is the US Trademark Image Download module?",
      answer:
        "A: The US Trademark Image Download module allows users to download trademark images associated with US trademark application numbers in bulk.",
    },
    {
      question: "Q: What image formats are supported?",
      answer:
        "A: Trademark images can be downloaded in either PNG or JPG format.",
    },
    {
      question: "Q: How do I download trademark images?",
      answer:
        "A: Enter one or more US trademark application numbers, select the desired image format (PNG or JPG), and initiate the download.",
    },
    {
      question: "Q: How many images can I download at once?",
      answer:
        "A: You can download up to 500 trademark images in a single request.",
    },
    {
      question: "Q: Can I download images for multiple application numbers simultaneously?",
      answer:
        "A: Yes. The module supports bulk processing, allowing you to enter multiple US trademark application numbers and download all associated images in one operation.",
    },
    {
      question: "Q: What happens if some application numbers do not have associated trademark images?",
      answer:
        "A: The system will download available images and notify you of any application numbers for which no trademark image could be found.",
    },
    {
      question: "Q: Can I choose different formats for different images in the same request?",
      answer:
        "A: No. A single download request can be processed in only one selected format—either PNG or JPG.",
    },
    {
      question: "Q: Are the downloaded images provided in their original quality?",
      answer:
        "A: Yes. The module retrieves and downloads the trademark images as available from the source records.",
    },
    {
      question: "Q: Is there a limit on the number of application numbers I can submit?",
      answer:
        "A: The module supports downloading up to 500 images per request. The number of application numbers that can be submitted depends on how many valid trademark images are associated with those applications.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {typeof faq.answer === "string" ? (
              <Typography sx={{ whiteSpace: "pre-line" }}>{faq.answer}</Typography>
            ) : (
              faq.answer
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default USTrademarkImageDownload;
